import { render, staticRenderFns } from "./image-select.vue?vue&type=template&id=53769710&scoped=true&"
import script from "./image-select.vue?vue&type=script&lang=js&"
export * from "./image-select.vue?vue&type=script&lang=js&"
import style0 from "./image-select.vue?vue&type=style&index=0&id=53769710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53769710",
  null
  
)

export default component.exports